import React from "react"
import { Foot } from "./style.css"
import { LaTercera } from "@labcon/copesa-logos"
import title from "../../images/title.png"
import LogoLab from "../../assets/logoLab.svg"

const Footer = () => {
  return (
    <Foot>
      <div className="logo box">
        <LaTercera schema="common" red="black" />
      </div>
      <div className="box">
        <img src={title} alt="andar juntas" />
      </div>
      <div>
        <p>Creado y diseñado por Laboratorio de Contenidos de Marca LT</p>
      </div>
      <div className="logo box">
        <img src={LogoLab} alt="andar juntas" />
      </div>
    </Foot>
  )
}

export default Footer
